import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, OnInit, viewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonAddressFieldWidget, CommonButtonRowWidget, CommonPhoneFieldWidget, CommonSelectFieldWidget, CommonTextFieldWidget } from '@eforall/common';
import { PersonDialogDataService } from '../../person-dialog-data.service';
import type { PersonDialog } from '../../person.dialog';
import { PersonBasicInfoForm } from './person-basic-info.form';

@Component({
	selector: 'person-basic-info-part',
	standalone: true,
	imports: [
		CommonTextFieldWidget,
		CommonAddressFieldWidget,
		CommonSelectFieldWidget,
		CommonPhoneFieldWidget,
		CommonButtonRowWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './person-basic-info.part.html'
})

export class BasicInfoPart implements OnInit, AfterViewInit {

	// Injecting parent dialog reference so this nested part can close the same open Material dialog from its local Close button
	public dialogRef = inject(MatDialogRef<PersonDialog>);

	private personDialogDataService = inject(PersonDialogDataService);
	public saveButton = viewChild.required<ElementRef<HTMLButtonElement>>('basicInfoSaveBtn');
	public basicInfoform = new PersonBasicInfoForm();


	ngOnInit(): void {
		this.setInitialValues();
	}

	ngAfterViewInit(): void {
		this.basicInfoform.form.setSubmitButton(
			this.saveButton(),
			async (values, changed: string[]) => {
				await this.personDialogDataService.updateBasicInfo(
					{
						firstName: values.firstName,
						middleInit: values.middleInit || undefined,
						lastName: values.lastName,
						fullName: '',
						contactMethodId: values.contactMethodId || undefined,
						phoneTypeId: values.phoneTypeId,
						phone: values.phone || undefined,
						doNotContactNote: values.doNotContactNote || undefined,
						googlePlaceKey: values.address?.googlePlaceKey,
						placeAddress: values.address?.placeAddress,
						stateCode: values.address?.stateCode,
						county: values.address?.county,
						latitude: values.address?.latitude,
						longitude: values.address?.longitude,
						zipId: values.address?.zipId,
						countyFipsId: values.address?.countyFipsId,
					}
				);
			}
		);
	}

	setInitialValues() {
		const personDetails = this.personDialogDataService.personDetails();
		if (!personDetails) return;
		this.basicInfoform.setValues(personDetails);
	}

	showViewMode() {
		this.personDialogDataService.toEdit.set(false);
	}

	onClose() {
		this.dialogRef.close();
	}
}